<template>
  <div>
    <v-autocomplete
      :value="fundAccount"
      :items="filterZones"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :multiple="false"
      :loading="loading"
      :clearable="clearable"
      :label="$i18n.t(label)"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float:right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";

@Component({
  name: "ZoneSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Zone",
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class ZoneSelect extends (Vue, Themeable) {
  fundAccount = null;
  loading = true;
  filter = "";
  zoneCreateDialog = false;
  fundAccounts = [];

  clear() {
    this.filter = "";
    this.zone = null;
    this.$emit("input", null);
  }

  get filterZones() {
    const zones = this.fundAccounts;
    return zones;
  }

  changedTo(value) {
    if (value) {
      this.$emit("input", value._id);
      return;
    }
    if (!value) {
      this.$emit("input", null);
    }
  }

  async populateFundAccounts() {
    try {
      const response = await doGet("/api/fund/account/grid");
      let modifiedArray = [];
      if (response && response["rows"] && response["rows"].length > 0) {
        modifiedArray = response["rows"].map((item) => {
          let name = "";
          if (item["details"] && item["details"]["identificationNumber"]) {
            name = name + item["details"]["identificationNumber"];
          }
          if (item["details"] && item["details"]["bankName"]) {
            name = name + " - " + item["details"]["bankName"];
          }
          return { _id: item["_id"], name: name };
        });
        this.fundAccounts = modifiedArray;
      }
    } catch (error) {
      console.log(error);
    }
  }
  async init() {
    this.filter = "";
    await this.populateFundAccounts();
    if (this.value) {
      for (let i = 0; i < this.fundAccounts.length; i++) {
        if (this.fundAccounts[i]._id === this.value) {
          this.fundAccount = this.fundAccounts[i];
          break;
        }
      }
    }
  }

  async addZone() {
    this.zoneCreateDialog = false;
    await this.init();
    this.changedTo();
  }

  async mounted() {
    await this.init();
    this.loading = false;
  }

  selected(val) {
    if (
      val != null &&
      val._id != null &&
      this.zone != null &&
      this.zone._id != undefined
    ) {
      if (val._id === this.zone._id) {
        return true;
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.fundAccount = null;
    }
    await this.init();
  }

  remove(val) {
    if (val != null && val._id != null && this.zone != null) {
      if (Array.isArray(this.zone)) {
        for (let i = 0; i < this.zone.length; i++) {
          if (val._id === this.zone[i]._id) {
            this.zone.splice(i, 1);
          }
        }
      }
    }
    return false;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}

.v-select-list {
  padding: 0;
}

.menuable__content__active,
.v-menu__content {
  background: white;
}

.v-select__selections {
  height: 32px;
}

.height32 {
  height: 32px;
}

.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}

.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
